import React from 'react'
// import InstagramFeed from './InstagramFeed'
import './Footer.css'

export default () => (
  <div>
    {/* <InstagramFeed count="8" /> */}
    <footer className="footer">
      <div className="container taCenter">
        <span>
          ©{' '}
          <a
            href="https://www.globalshaperscle.com/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Global Shapers Cleveland
          </a>{' '}
          {new Date().getFullYear()} All rights reserved. Made with &hearts; by{' '}
          <a
            href="https://ferasdeiratany.com/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Feras Deiratany
          </a>
          .
        </span>
      </div>
    </footer>
  </div>
)
